import {
  getUser,
  getUsersAuthorities,
  login,
  updateUser,
  setTimeZone as setTimeZoneApi,
  setUserPhone as setUserPhoneApi,
  setNotShowMessage as setNotShowMessageApi,
  getTPAuthToken,
  freemiumLImitNum,
  fillBasicInfo,
} from "@/api/user";
import { getEncryptionKey as getEncryptionKeyApi } from '@/api/encryption'
import { base64Encryption } from '@/tools/aes-encryption'
import { getStorage, removeStorage, setStorage, removeSessionStorage } from "@/utils/storage";
import { rankToRole, rankToRoleName } from "@/utils/role";
import { getTimeZone } from "@/config/time-zone";
import { getOnboardingStatus } from '@/api/onboarding'
import store from '@/store'
import {DispatchComponents$, systemInfo} from "@/shared-services";
import {mfRegister,mfWalletRegister} from "@/tl-mf-config";
import {meInitializedStatus$} from "@/data-services/subjects";
import moment from 'moment-timezone'
import { getAccountWalletInfo, isUserInBlacklist } from "@/api/wallet";
import {OnBoarding$} from "@/shared-services";

export default {
  namespaced: true,
  state: () => ({
    userTimezone: moment.tz.guess(),
    marketingUtm: undefined,
    utm: undefined,
    loadStatus: undefined,
    driverStatus: undefined,
    hasBaseDialerSeat: undefined,//dialer acount
    isDoNotDisturb: undefined, //dialer status
    userInfoId: undefined, //dialer status
    unreadCalls: undefined,//dialer
    registEmail: null,
    totalOperator: null,
    totalDriver: null,
    email: undefined,
    firstName: undefined,
    lastName: undefined,
    phone: undefined,
    rank: undefined,
    // 未激活的admin存在的未完成的订单信息
    subscriptionId: null,
    subscription_status: null,
    accountSubType: null,
    subscriptionInfo: null,
    expiredDemoAccount: false, // demo账号是否过期
    timeZone: 'EST',
    timeZoneFullName: getTimeZone('EST'),
    avatarUrl: null,
    reacquire: false,
    unfinishedInfo: null,
    onboardingShow: null,
    onboardingFlag: false,
    userTpId: null,
    demoType: null,
    expireDate: null, // 账号过期时间
    expiredTrialAccount: false, // trial账号是否过期
    role: null,
    companyName: '',
    companyChannel: null,
    userChannel: null,
    city: null,
    userId: null,
    dot: null,
    companyPhone: null,
    firstLogin: null,
    trucksNumber:0,
    welcomeStep:null,
    availableDriver:null,
    connectEld: null,
    addDriver: null,
    show_mess: null,
    topHeight: 40, // The minimum value is 40, and the minimum value represents the height of the top-bar
    showSupport: false, // 是否展示右下角按钮
    paymentVersion: 1, // 支付版本
    diamondWelcomeDialogVisible: false,
    showDispatchingFee: null,
    usersAuthorities: {},
    activeDriver:null,
    activeOperator:null,
    availableOperator:null,
    systemSourceOrigin: systemInfo.isCommand ? "fleet" : "dispatcher", // Which system
    XAuthToken: null,
    systemSource:null, // Command login user is relation with the DSP system
    uploadDocLeft: 0,
    assginLoadLeft: 0,
    freeDocTotal: 0,
    freeLoadTotal: 0,
    registeredTrial: null,
    fuelCardGuide: null,
    freemiumStep: 0,
    dialerSubscriptionGuide: false,
    subscriptionGuide: false,
    insuranceGuide: false,
    subscriptionCount: {
      dialerSubscriptionCount: 1,
      subscriptionCount: 1,
    },
    scheduleGuide: null,
    scheduleWelcome: false,
    companyEmail: null,
    helpHeight: 0,
    isSubscription: false,
    guideList: null,
    companyId: null,
    backofficeBundledOrder: null,
    baseInfoStatus: null,
    interestedStatus: null,
    startFreeTrialStatus: null,
    routeSendTempStatus: null,
    sidebarIsUnfold: false,
    trailDiscount: '',
    WalletInfo: null,
    checkUnAssignedNumber: false,
    showDialerGuide: false,
    bookMeetingStatus: false,
    hasCard: false,
    userBehaviors: null,
    isDowngrade: false,
    companyVersion: null,
    onboardingTotal: null,
    onboardedNumber: null,
    quickOnboardStatus: null,
    fuelSaveStatus: null,
    loadBoardStatus: null,
    onboardingGuide: null,
    dayCount: null,
    discountRate: null
  }),
  getters: {
    /**
     * 权限控制使用
     */
    role (state) {
      // 登录后返回角色
      if (state.email) {
        return rankToRole(state.rank);
      }
    },
    /**
     * 界面显示使用
     */
    roleName (state) {
      return rankToRoleName(state.rank);
    },
    subscriptionId(state) {
      return state.subscriptionId
    },
    subscription_status (state) {
      return state.subscription_status
    },
    subscriptionInfo (state) {
      return state.subscriptionInfo
    },
    reacquire(state) {
      return state.reacquire
    },
    usersAuthorities: (state) => state.usersAuthorities,
    userId: (state) => state.userId,
    systemSourceOrigin: (state) => state.systemSourceOrigin,
    systemSource: (state) => state.systemSource,
    companyName: (state) => state.companyName,
    registEmail: (state) => state.registEmail,
    uploadDocLeft: (state) => state.uploadDocLeft,
    assginLoadLeft: (state) => state.assginLoadLeft,
    freeLoadTotal: (state) => state.freeLoadTotal,
    freeDocTotal: (state) => state.freeDocTotal,
    demoType: (state) => state.demoType,
    registeredTrial: (state) => state.registeredTrial,
    freemiumStep:  (state) => state.freemiumStep,
    backofficeBundledOrder:  (state) => state.backofficeBundledOrder,
    helpHeight: state => state.helpHeight,
    scheduleWelcome: state => state.scheduleWelcome,
    topHeight: state => state.topHeight,
    hasCard: state => state.hasCard,
    userBehaviors: state => state.userBehaviors,
    isDowngrade: state => state.isDowngrade
  },
  mutations: {
    SET_HAS_CARD(state, status) {
      state.hasCard = status
    },
    SET_USER_BEHAVIOR_TYPE(state, list) {
      state.userBehaviors = list
    },
    SET_SCHEDULE_WELCOME(state, payload) {
      state.scheduleWelcome = payload
    }, 
    SET_SCHEDULE_GUIDE(state, payload) {
      state.scheduleGuide = payload
    }, 
    SET_USER_WALLET_INFO(state, payload){
      state.WalletInfo = payload
    },
    SET_USER_AVATAR(state, payload) {
      state.avatarUrl = payload
    },
    SET_REGIST_EMAIL(state, payload) {
      state.registEmail = payload
    },
    SET_USER_LEFT_NUM(state, data) {
      state.uploadDocLeft = data.upload
      state.assginLoadLeft = data.assign
      state.freeLoadTotal = data.totalAssign
      state.freeDocTotal = data.totalUpload
    },
    SET_USER_AUTHORITIES(state, payload) {
      state.usersAuthorities = payload
    },
    SET_X_AUTH_TOKEN(state, payload) {
      state.XAuthToken = payload
    },
    SET_USER(state, payload) {
      Object.keys(payload).forEach(key => {
        if (key === 'timeZone') {
          state.timeZone = ''
          state.timeZoneFullName = ''
        }
        if (key === 'connect_eld') {
          state.connectEld = payload[key]
        }
        if (key === 'add_driver') {
          state.addDriver = payload[key]
        }
        if (key === 'guideList') {
          state.guideList = payload.guideList ? JSON.parse(payload.guideList) : []
          return null
        }
        if (key in state) {
          state[key] = payload[key];
        }
      });

      // test
      if (
        process.env.NODE_ENV !== "production" ||
        process.env.VUE_APP_RUNTIME_ENV === "qa"
      ) {
        const rank = window.localStorage.getItem("_rank");
        if (rank) {
          import("element-ui/lib/message").then(({ default: Message }) => {
            Message.warning({
              message: `伪角色测试: ${rankToRole(rank)}`,
              duration: 5000,
              showClose: true
            });
          });
          state.rank = +rank;
        }
      }
    },
    SET_TIME_ZONE(state) {
      state.timeZone = ''
      state.timeZoneFullName = getTimeZone('')
    },
    SET_REACQUIRE(state, status) {
      state.reacquire = status
    },
    SET_PHONE(state, phone) {
      state.phone = phone
    },
    SET_UNFINISHED_INFO(state, data) {
      state.unfinishedInfo = data
    },
    SET_WELCOME_STEP(state, flag) {
      state.welcomeStep = flag
    },
    SET_CONNECTELD(state, flag) {
      state.connectEld = flag
    },
    SET_ADDDRIVER(state, flag) {
      state.addDriver = flag
    },
    SET_SHOWMESS(state, flag) {
      state.show_mess = flag
    },
    SET_SHOW_SUPPORT(state, status) {
      state.showSupport = status
    },
    SET_DIAMOND_WELCOME_DIALOG_VISIBLE(state, status) {
      state.diamondWelcomeDialogVisible = status
    },
    SET_CLICK_COUNT(state,key) {
      state.subscriptionCount[key]++
    },
    SET_HELP_HEIGHT(state, height) {
      state.helpHeight = height
    },
    SET_GUIDE_LIST(state, guideList) {
      state.guideList = guideList
    },
    SET_TOP_HEIGHT(state, topHeight) {
      state.topHeight = topHeight
    },
    SET_SIDEBAR_IS_UNFOLD(state, flag) {
      state.sidebarIsUnfold = flag
    },
    SET_DIALER_CONDITION(state, info) {
      state.checkUnAssignedNumber = info.checkUnAssignedNumber
      state.showDialerGuide = info.showPopup
    }
  },
  actions: {
    updateHasCard({ commit }, status) {
      commit('SET_HAS_CARD', status)
    },
    updateUserBehaviorType({ commit }, list) {
      commit('SET_USER_BEHAVIOR_TYPE', list)
    },
    updateDialerCondition({ commit }, info) {
      commit('SET_DIALER_CONDITION', info)
      OnBoarding$.subscribe(s => s.updateDialerCondition({
        checkUnAssignedNumber: info.checkUnAssignedNumber,
        hasNumber: info.showPopup
      }))
    },
    setScheduleWelcome({commit}) {
      commit('SET_SCHEDULE_WELCOME', false)
    },
    setScheduleGuide({commit}) {
      commit('SET_SCHEDULE_GUIDE', false)
    },
    getFreeNum({commit}) {
      freemiumLImitNum().then(res => {
        commit('SET_USER_LEFT_NUM', res.data || {})
      })
    },
    setRegistEmail({commit}, data) {
      commit('SET_REGIST_EMAIL', data)
    },
    async getUsersAuthoritiesF({ commit }) {
      const { data: usersAuthorities } = await getUsersAuthorities()
      commit('SET_USER_AUTHORITIES', usersAuthorities || {})
    },
    async getUser ({ commit ,state}) {
      if (systemInfo.isDispatch) {
        return
      }
      DispatchComponents$.subscribe(x => x.checkEndFreeTrial())
      const { data: XAuthToken } = await getTPAuthToken();
      const { data } = await getUser();
      OnBoarding$.subscribe(s => s.updateMeData(data))
      const { data: res }  = await getOnboardingStatus();
      const { data: usersAuthorities } = await getUsersAuthorities()
      if(data) {
        // Carrier module
        if (state.XAuthToken !== XAuthToken) {
          mfRegister(
            XAuthToken,
            data.systemSource === "dispatcher"
              ? usersAuthorities["fleet:carrierBusiness:editSelfEntity"] ===
                  "true"
              : true
          );
        }
        
        let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
        if(userInfo.password){
          delete userInfo.password
          localStorage.setItem('userInfo', JSON.stringify(userInfo))
        }
        // Wallet module
        mfWalletRegister(data)

        try {
          // get Wallet setting info
          const walletRes = await getAccountWalletInfo({
            accountId: data.companyId,
            accountType: "fleet",
          });
          const blackRes = await isUserInBlacklist(data.userTpId)
          walletRes.data.isInBlacklist = blackRes.data;
          commit("SET_USER_WALLET_INFO", walletRes?.data || null);
        } catch (error) {
          error
          commit("SET_USER_WALLET_INFO", null);
          // do nothing
        }
        
      }
      commit('SET_X_AUTH_TOKEN', XAuthToken)
      // todo
      store.dispatch("im/initIMToken", XAuthToken);
      commit('SET_USER_AUTHORITIES', usersAuthorities || {})
      let role = rankToRole(data.rank)
      commit("SET_USER", Object.assign(data, {
        avatarUrl: data.avatar,
        role,
      },res));
      meInitializedStatus$.next(true)
      commit("SET_REACQUIRE", false);
      store.dispatch("im/initIMToken");
      if (
          (document.location.pathname !== "/login" &&
            document.location.pathname !== "/dashboard") ||
          (document.location.search &&
            document.location.search.substring(1).split("=")[1] !==
              "%2Fdashboard")
        ) {
          let timer = setInterval(function () {
            // 判断文档和所有子资源(图片、音视频等)已完成加载
            if (document.readyState === 'complete') {
                //执行方法
                setTimeout(() => {
                  window.clearInterval(timer)
                });
            }
        }, 500)
      }
      return Promise.resolve({ role });
    },
    async getPaymentSettingInfo({ commit }, param) {
      const res = await getAccountWalletInfo(param);
      commit("SET_USER_WALLET_INFO", res.data || null);
    },
    async getOnboardingStatus({ commit }, fleetCompanyId) {
      let data = {};
      if(systemInfo.isCommand) {
        data = await getOnboardingStatus();
      } else {
        if(fleetCompanyId) {
          data = await getOnboardingStatus({ fleetCompanyId: fleetCompanyId });
        }
      }
      commit("SET_ADDDRIVER", data.data.add_driver);
      commit("SET_CONNECTELD", data.data.connect_eld);
    },
    setAvatar({commit}, data) {
      commit('SET_USER_AVATAR', data)
    },
    updateUser({ state, commit }, data) {
      return updateUser(data).then((res) => {
        commit("SET_USER", Object.assign(res, {avatarUrl: state.avatarUrl}));
        commit("SET_REACQUIRE", false);
      });
    },
    login({dispatch}, payload) {
      return login(payload).then((res) => {
        const IMAuth = {
          token: res.data.chatToken,
          accid: res.data.accid
        }
        setStorage(IMAuth, 'IMAuth')
        setStorage(res.data.token);
        removeSessionStorage('dialerSubscriptionCount');
        removeSessionStorage('subscriptionCount');
        removeSessionStorage('isToRoute');
        // dispatch('im/initIMToken', IMAuth, {root: true});
        dispatch('getEncryptionKey')
        return Promise.resolve(res.data);
      });
    },
    logout({ state }) {
      if(!systemInfo.isCommand) {
        return;
      }
      let logoutTimestamp = new Date().getTime();
      setStorage(logoutTimestamp,'logoutTimestamp');
      if (getStorage()) {
        removeStorage();
        removeStorage('IMAuth')
        removeStorage('encryptKey')
        removeStorage('x-portal-token')
        removeStorage('x-user-readOnly')
        removeStorage('newUser')
        sessionStorage.removeItem('qboIntegrationConnectedUrlStorage')
        sessionStorage.removeItem('_payItemData')
        sessionStorage.removeItem("timestampFlag");
        sessionStorage.removeItem("enterOnboarding")
      }
      if (state.email || !/^\/login(\/.*)?$/.test(location.pathname)) {
        window.location.href = '/map/index?isLogin=true'
      }
    },
    setTimeZone({ commit }, timeZone) {
      return setTimeZoneApi(timeZone).then(() => {
        commit('SET_TIME_ZONE', timeZone)
        return Promise.resolve()
      }).catch(({ error }) => Promise.reject(error))
    },
    updateReacquire({ commit }, status) {
      commit('SET_REACQUIRE', status)
    },
    setUerPhone({ commit }, phone) {
      return setUserPhoneApi(phone).then(res => {
        commit('SET_PHONE', phone)
        commit('SET_UNFINISHED_INFO', null)
        return res
      })
    },
    // 获取aes加密密钥
    getEncryptionKey() {
      return getEncryptionKeyApi().then(res => {
        try {
          let key = res.data.data.encryptKey
          setStorage(base64Encryption(key), 'encryptKey')
        } catch(error) {
          console.log(error)
        }
      })
    },
    // setNotShowMessage
    setNotShowMessage({ commit }, data = {}) {
      return setNotShowMessageApi(data).then(( res ) => {
        if(res.code == '200') {
          commit("SET_SHOWMESS", false);
        }
      });
    },
    updateShowSupportStatus({ commit }, status) {
      commit('SET_SHOW_SUPPORT', status)
    },
    updateDiamondWelcomeDialogVisible({ commit }, status) {
      commit('SET_DIAMOND_WELCOME_DIALOG_VISIBLE', status)
    },
    updateFreemuimInfo() {
      fillBasicInfo({
        closeTab: true,
        convertToTrial: false,
      })
    },
    recordClickCount({commit}, key) {
      commit('SET_CLICK_COUNT', key)
    },
    updateHelpHeight({ commit }, height) {
      commit('SET_HELP_HEIGHT', height)
    },
    updateGuideList({ commit }, guideList) {
      commit('SET_GUIDE_LIST', guideList)
    },
    updateTopHeight({ commit }, topHeight) {
      commit('SET_TOP_HEIGHT', topHeight)
    }
  }
};
